export enum Environment {
  LIVE = 'live',
  STAGING = 'staging',
  STAGING_CLOUD = 'staging-cloud',
  DEVELOPMENT = 'development',
}
